'use client';

import React, { PropsWithChildren } from 'react';
import * as Content from '@/components/content';
import { useTranslations } from 'next-intl';

const { Card } = Content;

const CardWrapper = ({ children }: PropsWithChildren) => (
  <div className="grid grid-cols-1 gap-4 md:gap-5 lg:grid-cols-2">
    {children}
  </div>
);

const keys = ['0', '1', '2', '3'] as const;
function Unacceptable() {
  const t = useTranslations('Sample.unacceptable');

  const title = t.rich('title', {
    br: () => <br className="hidden md:block" />,
  });

  const cards = keys.map(key => ({
    title: t.rich(`cards.${key}.title`, {
      br: () => <br className="hidden md:block" />,
    }),
    description: t.rich(`cards.${key}.description`, {
      br: () => <br className="hidden md:block" />,
    }),
  }));

  return (
    <Content.Section>
      <Content.Title title={title} />
      <CardWrapper>
        {cards.map(({ title, description }, index) => (
          <Card key={index}>
            <Card.Title>{title}</Card.Title>
            <Card.Description>{description}</Card.Description>
          </Card>
        ))}
      </CardWrapper>
    </Content.Section>
  );
}

export default Unacceptable;
